import { postRunWorkflowStep } from '@/redux/actions/gravityActions.js';
import { store } from '@/redux/lib/configureStore';
import { param } from '@/redux/selectors/uiSelectors';
import { query } from '@/redux/selectors/querySelectors';

const runActiveWorkflowScreenStep = (callback, opts = {}) => {
  const state = store.getState();
  const workflowId = param(state, 'workflowId');
  const stepId = query(state, 'stepId');
  const runEnvironment = state?.ui?.prefs?.[`workflowRunEnvironment-${workflowId}`];
  const defaultEnvironment = state?.settings?.environments?.find((env) => env.isDefault)?.id;
  const installationId = state?.workflow?.workflows?.find((w) => w?.id === workflowId)?.installationId;

  postRunWorkflowStep(
    {
      workflowId,
      stepId,
      environmentId: opts?.environmentId || runEnvironment || defaultEnvironment,
      installationId
    },
    callback
  );
};

export default runActiveWorkflowScreenStep;
